const TranslationService = function() {

    let translations = {};
    let callbacks = new Map();
    let currentContext;

    function setTranslations(context, strings) {
        //console.log("context:",context+" strings:",strings);
        currentContext = context;
        translations[context] = strings;

        if (callbacks.size > 0) {
            callbacks.forEach((value,key) => {
                if(key == context)
                    value(tanslations[context]);
            })
        }
    }

    function getTranslations(context, callback) {
        if (callback) {
            callbacks.set(context, callback);
        }
        return translations[context];
    }

    function getCurrentContext() {
        // console.log('service getCurrentContext: ', currentContext);
        return currentContext;
    }

    function setCurrentContext(context) {
        // console.log('service getCurrentContext: ', context);
        currentContext = context;
    }

    return {
        setTranslations: setTranslations,
        getTranslations: getTranslations,
        setCurrentContext: setCurrentContext,
        getCurrentContext: getCurrentContext
    }
};

export default TranslationService;